import { LazyLoad } from 'app/utils';

export const StatementListPage = LazyLoad(
  () => import('./index'),
  (module) => module.StatementListPage,
);
